const FileRejected=(props)=>{
    return <ul> {props.RejectedFiles?.map(({ file, errors }) => {
        return (
            <li key={file.path}>
                {file.path} - {file.size} bytes
                <ul>
                    {errors?.map(e => <li key={e.code}>{e.message}</li>)}
                </ul>

            </li>
        )
    })}</ul>
}
export default FileRejected